import * as React from 'react';

import { i18nService } from 'modules/language-provider/i18n.service';
import AnalyticsService from 'modules/analytics-provider/analytics-provider.service';

import { Icon, ICON_NAME } from 'components/icon';
import { translate } from 'components/translate-hoc';
import { formatUnit } from '../units-formatter';

import { TEXT_KEYS, INVITATION_ANALYTICS } from './invitation.constants';

import './invitation.styles.less';

import { IInvitationProps } from './invitation.container';

export class Invitation extends React.Component<IInvitationProps> {
    private acceptInvitation = async () => {
        const joinButtonText: string = i18nService.getAnalyticsLabel(TEXT_KEYS.BUTTON_ACCEPT);
        AnalyticsService.sendClickEvent( INVITATION_ANALYTICS(joinButtonText.toLowerCase()) );
        return this.props.acceptInvitation();
    };

    public render(): JSX.Element {
        const { dangerouslyTranslateWithHTML: translateKey, paramThreshold, invitationInfo, statsFormatting } = this.props;
        const title: string = translateKey(TEXT_KEYS.TITLE);
        const formattedParamTreshold = formatUnit(paramThreshold, statsFormatting);
        const description: string = translateKey(TEXT_KEYS.DESCRIPTION, {
            username: invitationInfo.username,
            platform: invitationInfo.platformId,
            paramThreshold: formattedParamTreshold
        });
        const campaignDescription: string = translateKey(TEXT_KEYS.CAMPAIGN_DESCRIPTION, { paramThreshold: formattedParamTreshold });
        const joinButtonText: string = translateKey(TEXT_KEYS.BUTTON_ACCEPT);
        const warningText: string = translateKey(TEXT_KEYS.WARNING);
        return (
            <div className="sitegen-fr-invitation">
                <div className="sitegen-fr-invitation__caption">
                    {translateKey(TEXT_KEYS.CAPTION)}
                </div>
                <h2 className="sitegen-fr-invitation__title">{title}</h2>
                <div className="sitegen-fr-invitation__content">
                    <div className="sitegen-fr-invitation__content-title">{description}</div>
                    <div className="sitegen-fr-invitation__content-description">{campaignDescription}</div>
                    <button onClick={this.acceptInvitation} className="sitegen-fr-invitation__accept">
                        {joinButtonText}
                    </button>
                    <div className="sitegen-fr-invitation__warning">
                        <Icon name={ICON_NAME.WARNING} />
                        {warningText}
                    </div>
                </div>
            </div>
        );
    }
}

export const InvitationWithTranslations = translate()(Invitation);
